// Import database API
import {
    login as databaseLogin,
    logout as databaseLogout,
    getUser as databaseGetUser,
    onUserChange,
} from '../database/endpoints/auth.api';

// Function to login to the db
export async function login(email, password) {
    try {
        // Try to connect to the database
        await databaseLogin(email, password);
    } catch (err) {
        console.error(
            `Error while login to the database\nError message: ${err.message}`,
        );
        throw err;
    }
}

// Function to logout from the db
export async function logout() {
    try {
        // Try to logout from the database
        await databaseLogout();
    } catch (err) {
        console.error(
            `Error while logout from the database\nError message: ${err.message}`,
        );
        throw err;
    }
}

// function to get current user
export async function getUser() {
    try {
        // Tru to get the current user
        return await databaseGetUser();
    } catch (err) {
        console.error(
            `Error while getting the current user\nError message: ${err.message}`,
        );
        throw err;
    }
}

// Function to get a subscriber on user changes
export function getUserChangeSubscriber(callback) {
    // Link a callback on user change and get the subscriber
    const { subscription } = onUserChange(callback);

    return subscription;
}
